import { useEffect } from 'react';
import { Popover, PopoverContent } from '@/components/ui/popover.tsx';
import { NotificationTrigger } from './notification-popover-trigger.tsx';
import { NotificationContent } from './notification-popover-content.tsx';
import { cn } from '@/utils/utils.ts';
import { useNotificationsStore } from '@/services/store/use-notifications-store.ts';

export const NotificationPopover = () => {
  const isPopoverOpen = useNotificationsStore((state) => state.isPopoverOpen);
  const setIsPopoverOpen = useNotificationsStore((state) => state.setIsPopoverOpen);

  useEffect(() => {
    setIsPopoverOpen(false);
  }, [setIsPopoverOpen]);

  return (
    <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full p-0">
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <NotificationTrigger />
        <PopoverContent
          className={cn(
            'relative mr-4 w-[340px] overflow-hidden rounded-lg border bg-white/95 p-0 shadow-xl backdrop-blur-xl sm:w-[360px] dark:bg-gray-900/95'
          )}
          sideOffset={8}
        >
          <NotificationContent />
        </PopoverContent>
      </Popover>
    </div>
  );
};
